<nav class="navbar navbar-light bg-light navbar-expand-lg ">
  <div #buscador class="collapse navbar-collapse" id="navbarSupportedContent">
    <!--Buscar cliente-->
    <div class="form-inline me-2">
      <input id="busquedaFormControl" [formControl]="buscadorFormControl" type="text" class="form-control" (input)="filtrarClientesPorTexto()"
        placeholder="Razón social/cuenta/cuit" />
    </div>
    <ul class="navbar-nav me-auto">

      <!--Nuevo cliente-->
      <li class="nav-item me-2">
        <button type="button" class="btn btn-outline-primary my-2" [disabled]="!terminoCargaClientes || !usuarioPuedeCrearClienteExtranjero()" (click)="nuevoClienteExtranjero()">Nuevo Cliente Extranjero</button>
      </li>
      <!--Nuevo cliente-->
      <li class="nav-item me-2">
        <button type="button" class="btn btn-outline-primary my-2" [disabled]="!terminoCargaClientes || !usuarioPuedeCrearClienteAfip()" (click)="nuevoClienteAfip()">Nuevo Cliente</button>
      </li>
      <!--Filtro clientes-->
      <li class="nav-item">
        <div ngbDropdown autoClose="outside">
          <button class="btn btn-outline-primary my-2" id="dropdownForm1"
            ngbDropdownToggle>Estado cliente</button>

          <div ngbDropdownMenu aria-labelledby="dropdownForm1">
            <div class="px-4 py-3">
              <div *ngFor="let estado of estados">
                <div class="form-check">
                  <input type="checkbox" class="form-check-input" id="{{ 'dropdownCheck' + estado.valor}}"
                    [(ngModel)]="estado.seleccionado" (change)="filtrarClientesPorEstado(estado)">
                  <label class="form-check-label text-nowrap" for="{{ 'dropdownCheck' + estado.valor}}">
                    {{ estado.descripcion }}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</nav>
<div class="row">
  <div class="col col-3">
    <div class="list-group py-3 menu-izq">
      <app-clientes-lista [estados]="estados$ | async" [clienteBuscado]="clienteBuscado" [clienteParaAgregar]="clienteParaAgregar" (clienteSeleccionado)="mostrarCliente($event)" (clienteVerificar)="enviarCliente($event)" (terminoCargaClientes)="termino()"></app-clientes-lista>
    </div>
  </div>
  <div class="col col-9 py-3" *ngIf="abrirCliente">
    <app-clientes-informacion [clienteAFIP]="clienteBuscadoAFIP" [clienteExtranjero]="clienteExtranjero" [clienteSeleccionadoParaEditar]="clienteABuscar" [todosLosClientesEncabezado]="clientesVerificar" (clienteCreado)="agregarCliente($event)" (terminoCargaClientes)="termino()"></app-clientes-informacion>
  </div>
</div>
